export enum EnvTypes {
    LOCAL = 'LOCAL',
    STAGE = 'STAGE',
    PRODUCTION = 'PRODUCTION',
}
